/* =====================================================================
   Antistatik · fiche produit v2 : comportements chargés en différé (M1, v3.4, 23/10/2026)
   Chargé par sections/main-product.liquid (attribut defer) sur les fiches v2 seulement. Styles : assets/ask-v2-fiche.css § 2 bis.

   Galerie d'ordinateur (dès 990 px) : les vignettes forment une colonne à gauche de la grande photo. Ce script
   - ajoute deux flèches rondes (haut, bas) qui ne s'affichent que si la colonne dépasse la hauteur de la photo, et
     seulement du côté où il reste des vignettes ;
   - garde la vignette active dans la colonne quand la photo change (clic, coloris choisi) : Dawn ne sait faire défiler ses
     vignettes qu'à l'horizontale (assets/global.js, SliderComponent).
   Il ne fait jamais défiler la page, seulement la colonne. Téléphone et tablette : rien (vignettes masquées ou en ligne).
   Les flèches servent à la souris ; au clavier, chaque vignette est déjà un bouton atteignable (la colonne suit le focus).
   ===================================================================== */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 990px)');
  var FLECHE = { haut: 'm6 15 6-6 6 6', bas: 'm6 9 6 6 6-6' };

  function bouton(sens) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ask-galerie__fl ask-galerie__fl--' + sens;
    b.tabIndex = -1;
    b.setAttribute('aria-hidden', 'true');
    b.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="' + FLECHE[sens] + '"/></svg>';
    b.hidden = true;
    return b;
  }

  function initColonne(galerie) {
    var sl = galerie.querySelector(':scope > .thumbnail-slider');
    var liste = sl && sl.querySelector('.thumbnail-list');
    if (!liste || sl.hasAttribute('data-ask-col')) return;
    sl.setAttribute('data-ask-col', '');
    var haut = bouton('haut'), bas = bouton('bas'), raf = 0;
    sl.appendChild(haut);
    sl.appendChild(bas);

    function pas() { return Math.max(80, liste.clientHeight - 120); }
    haut.addEventListener('click', function () { liste.scrollBy({ top: -pas(), behavior: 'smooth' }); });
    bas.addEventListener('click', function () { liste.scrollBy({ top: pas(), behavior: 'smooth' }); });

    function maj() {
      raf = 0;
      var deborde = mq.matches && liste.scrollHeight > liste.clientHeight + 2;
      haut.hidden = !deborde || liste.scrollTop <= 2;
      bas.hidden = !deborde || liste.scrollTop + liste.clientHeight >= liste.scrollHeight - 2;
    }
    function planifier() { if (!raf) raf = requestAnimationFrame(maj); }

    /* Vignette active hors de la colonne visible : la colonne défile pour la centrer (jamais la page). */
    function montrerActive() {
      if (!mq.matches) return;
      var b = liste.querySelector('.thumbnail[aria-current]');
      var li = b && b.closest('.thumbnail-list__item');
      if (!li || !li.offsetHeight || liste.scrollHeight <= liste.clientHeight + 2) return;
      var top = li.offsetTop, h = li.offsetHeight, vh = liste.clientHeight, st = liste.scrollTop;
      if (top >= st && top + h <= st + vh) return;
      liste.scrollTo({ top: Math.max(0, top - (vh - h) / 2), behavior: 'smooth' });
    }

    liste.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    if (mq.addEventListener) mq.addEventListener('change', planifier);
    new MutationObserver(function () { montrerActive(); planifier(); })
      .observe(liste, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-current'] });
    if ('ResizeObserver' in window) new ResizeObserver(planifier).observe(liste);
    window.addEventListener('load', function () { montrerActive(); planifier(); });
    montrerActive();
    planifier();
  }

  function init() {
    document.querySelectorAll('product-info.ask-fiche media-gallery').forEach(initColonne);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Galerie redessinée par Dawn (changement de produit) : on recommence sur la nouvelle. */
  document.querySelectorAll('product-info.ask-fiche .product__media-wrapper').forEach(function (w) {
    new MutationObserver(init).observe(w, { childList: true });
  });
})();
